import { call, put, takeEvery } from 'redux-saga/effects';
import { CHANGE_USER_AVATAR_REQUEST } from '../constants/change_user_avatar.constants';
import { changeUserAvatar } from '../../requests/user_profile_requests/change_user_avatar_request';
import { changeUserAvatarRequestSuccess, changeUserAvatarRequestFailure } from '../actions/change_user_avatar.actions';
import { message_success, message_error } from '../../../../../components/Message';
import { getUserInfo } from '../../../../App/requests/get_content_request';
import { getUserInfoSuccess } from '../../../../App/redux/actions/user_info.actions';

function* changeUserAvatarRequest({ id, data }) {
    const { result, options, error } = yield call(changeUserAvatar, id, data);
    if (result) {
        yield put(changeUserAvatarRequestSuccess(options.photos));
        const { result, options: { user_info } } = yield call(getUserInfo);
        if (result) yield put(getUserInfoSuccess(user_info));
        message_success('User avatar is changed successfully!');
    } else {
        yield put(changeUserAvatarRequestFailure(error));
        message_error(error);
    }
}

export default function* changeUserAvatarSaga() {
    yield takeEvery(CHANGE_USER_AVATAR_REQUEST, changeUserAvatarRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/change_user_avatar.saga.js